export enum MetroxTrackingLabels {
    Login = 'login',
    SignUp = 'sign-up',
    Logo = 'logo',
    OnlineShop = 'onlineshop',
    MyStoreBucket = 'my-store-bucket',
    DeliveryBucket = 'delivery-bucket',
    InfosAndServicesBucket = 'infos-and-services-bucket'
}
